const getters = {
  // app
  keepAlive: state => state.app.keepAlive,
  userInfo: state => state.app.userInfo,

  // settlement
  settlementData: state => state.settlement.settlementData
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js